import * as microsoftTeams from "@microsoft/teams-js";

export interface IMicrosoftTeamsAccessTokenProvider {
    getAccessToken: () => Promise<string>;
}

const microsoftTeamsAccessTokenProvider: IMicrosoftTeamsAccessTokenProvider = {
    getAccessToken: async () => {
        return await microsoftTeams.authentication.getAuthToken();
    },
};

export default microsoftTeamsAccessTokenProvider;
